import React from "react";
import { Stack, Typography } from "@mui/material";

import WorkOrderLabel from "./WorkOrderLabel";
import { NotesStack, StyledBaseBox } from "./styles";
import { useMaterialListWithCache } from "../../components/HubMaterialHookSelect/useMaterialListWithCache";
import { useStationListWithCache } from "../../components/StationHookFormSelect";
import { getWorkOrderInstructions } from "./helper";

const border = "1px solid black";

const sx = {
  variant: "caption",
  boxSizing: "borderBox",
  height: "15px",
  px: "5px",
  borderTop: border,
  borderLeft: border,
  fontWeight: 500,
  fontSize: "11px",
};

const gridSx = {
  display: "grid",
  gridTemplateColumns: "auto 1fr 1fr auto",
  mt: "auto",
  borderRight: border,
  borderBottom: border,
};

const DipTable = ({ dips = [], base = 1, ...rest }) => {
  let length = dips?.length > 5 ? 5 : 5 - dips?.length;
  return (
    <Stack {...gridSx} {...rest}>
      <Typography {...sx}>#</Typography>
      <Typography {...sx}>Sand</Typography>
      <Typography {...sx}>Slurry</Typography>
      <Typography {...sx}>Prewet</Typography>
      {dips?.map(({ sand, slurry, prewet = true }, i) => (
        <>
          <Typography {...sx}>{i + base}</Typography>
          <Typography {...sx}>{sand}</Typography>
          <Typography {...sx}>{slurry}</Typography>
          <Typography {...sx}>{prewet ? "✔" : ""}</Typography>
        </>
      ))}
      {Array.from({ length: length * 4 }, (_, index) => index).map(() => (
        <Typography {...sx} />
      ))}
    </Stack>
  );
};

const getMaterial = (materials = [], id) => {
  const material = materials?.find((m) => m.id === id);
  return material?.label;
};

const getStation = (stations = [], id) => {
  const station = stations?.find((m) => m.id === id);
  return station?.label;
};

const WorkOrderDip = ({ data }) => {
  const { materials: cached } = useMaterialListWithCache();
  const materials = Array.isArray(cached) ? cached : cached?.materials || [];
  const { stations = [] } = useStationListWithCache();

  let assembly = getWorkOrderInstructions(data, 12);
  let dip = getWorkOrderInstructions(data, 2);
  let dewax = getWorkOrderInstructions(data, 3);

  let dips = dip?.routing?.map(({ stationId, config }) => ({
    sand: getMaterial(materials, config?.materialId),
    slurry: getMaterial(materials, config?.slurryId),
    station: getStation(stations, stationId),
    prewet: config?.prewet,
  }));

  let dewaxStationId = dewax?.routing?.[0]?.stationId;
  let dewaxLabel = getStation(stations, dewaxStationId);

  let treesPerCluster = assembly?.config?.treesPerCluster;
  let treesPerLoad = dewax?.config?.treesPerLoad;

  return (
    <StyledBaseBox columns={2} rowGap="5px !important">
      <Typography variant="boldCaptionMain">Shell Department</Typography>
      <Stack
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(2, 1fr)`,
          gap: "25px",
        }}
      >
        <WorkOrderLabel label="# OF DIPS" value={dips?.length} valueBold />
        <WorkOrderLabel
          label="TREES/CLUSTER"
          value={treesPerCluster}
          valueBold
        />
      </Stack>
      <NotesStack col="2">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          DIP INST: <strong>{dip?.notes}</strong>
        </Typography>
      </NotesStack>
      {dips && (
        <>
          <DipTable dips={dips.slice(0, 5)} />
          <DipTable dips={dips.slice(5, 10)} base={6} />
        </>
      )}
      <Stack
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(2, 1fr)`,
          gap: "25px",
        }}
      >
        <WorkOrderLabel label="DEWAX STATION" value={dewaxLabel} valueBold />
        <WorkOrderLabel label="TREES/LOAD" value={treesPerLoad} valueBold />
      </Stack>
      <NotesStack col="2">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          INST: <strong>{dewax?.notes}</strong>
        </Typography>
      </NotesStack>
    </StyledBaseBox>
  );
};

export default WorkOrderDip;
